module.exports = __webpack_public_path__ + "media/images/metronic/loading-spinner-blue-66e44ee126d507443c78c440c21742a3.gif";